import { Form } from 'antd';
import { contractService } from 'contract/services/contractService';
import { ContractInterface } from 'contract/type';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { platformApiService } from 'service/api/platformApiService';
import { PlatformInterface } from 'type/platformType';
import * as Component from '../../../../shared/components';
import * as ContractComponent from './components';
import { detailHandlers } from './handlers';

const ContractEdit: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [contractForm] = Form.useForm(); // Contract용 별도 form
  const [termForm] = Form.useForm(); // Term용 별도 form
  const [platformList, setPlatformList] = useState<PlatformInterface[]>([]);
  const [loading, setLoading] = useState(true);
  const [contract, setContract] = useState<ContractInterface>();
  const [termList, setTermList] = useState<{ id: number; title: string }[]>([]);

  const { handleOnClickEditButtonClick } = detailHandlers({
    id: id || '0',
    form: contractForm,
    navigate,
  });

  const fetchPlatform = async (): Promise<void> => {
    const platformData = await platformApiService.fetchPlatformList();
    setPlatformList(platformData);
  };

  const fetchTermList = async () => {
    const terms = await contractService.fetchTerms(Number(id));
    setTermList(terms);
  };

  useEffect(() => {
    fetchPlatform().then();
    fetchTermList();
  }, []);

  useEffect(() => {
    const fetchContract = async (): Promise<void> => {
      const contract = await contractService.fetchById(Number(id));
      if (contract) {
        setContract(contract);
        // Contract 폼에만 초기값 설정 (Term 폼은 별도로 관리)
        contractForm.setFieldsValue(contract);
        fetchPlatform().then();
      }
      setLoading(false);
    };

    fetchContract().then();
  }, [id, contractForm]);

  const contractComponents = [
    {
      key: 'general',
      title: 'General Info',
      component: (
        <div>
          <ContractComponent.DetailComponent
            form={contractForm}
            companyList={[]}
            platformList={platformList}
            contract={contract}
            actionTitle="SAVE"
            handleOnClickButtonClick={handleOnClickEditButtonClick}
          />
        </div>
      ),
    },
    {
      key: 'terms',
      title: 'Terms',
      component: (
        <ContractComponent.TermDetailComponent
          form={termForm}
          contractId={Number(id)}
          termList={termList}
          onTermListRefresh={fetchTermList}
        />
      ),
    },
  ];

  return (
    <Component.BasePageComponent>
      {loading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <Component.TapComponent components={contractComponents} />
      )}
    </Component.BasePageComponent>
  );
};

export default ContractEdit;
